import client from '../client'

export const searchVehiclesKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Search/SearchVehicles`

export async function searchVehicles(elasticQuery) {
  return client(searchVehiclesKey, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({
      searchRequest: elasticQuery,
    }),
  })
}
